/**
 * 官网联系我们（匿名接口）
 * @returns {Promise<Object>}
 */
export function fetchPublicContact() {
  const prefix = process.env.VUE_APP_BASE_API || ''
  return fetch(prefix + '/web/contact/public', {
    method: 'GET',
    headers: { Accept: 'application/json' },
  })
    .then((res) => res.json())
    .then((body) => {
      if (body.code !== 200) {
        throw new Error(body.msg || '加载失败')
      }
      return body.data || {}
    })
}
